import React from 'react'
import { Box, BoxProps, Container } from '@chakra-ui/react'
import { useQuery } from '@tanstack/react-query'

import Head from '@modules/common/components/head'
import BrandLayout from '@layouts/brand-layout'
import { getBrand } from '@lib/util/brand-handler'

import useAosAnimation from '@common/hooks/use-aos-animation'
import Hero from './hero'
import Ingredient from './ingradient'
import Video from './video'
import Efficiency from './efficiency'
import Products from './product'
import ProductIntro from './product-intro'
import Certification from './certification'
import ProductIntro2 from './product-intro-2'
import ProductIntro3 from './product-intro-3'
import Testimony from './testimony'
import SocialMedia from './social-media'
import Result from './result'

export const COLOR = {
  DARK: '#1b1d1d',
  LIGHT: '#ffffff',
  BLACK: '#000',
  YELLOW: '#D9D3A6',
  NAVY: '#21353F',
  GRAY: '#D2D2D2'
}

export const MainContainer = (props: BoxProps) => {
  return (
    <Container
      className="xl:max-w-[1366px] lg:max-w-[992px] md:max-w-[768px] max-w-[600px]"
      {...props}
    />
  )
}

const Zero2One = () => {
  const { data } = useQuery(['brand', 'ellixi'], () => getBrand('ellixi'))

  useAosAnimation({
    duration: 600,
    once: false
  })

  if (!data) return null

  const { title, metadata, productSection } = data

  return (
    <>
      <Head title={title} description={metadata.meta_description} />
      <BrandLayout
        name={title}
        color={COLOR.BLACK}
        brand={data}
        productSection={productSection}
      >
        <Box bgColor={COLOR.DARK} data-aos="fade-up">
          <Hero />
        </Box>

        <Box data-aos="fade-up">
          <Ingredient />
        </Box>

        <Box data-aos="fade-up">
          <Video />
        </Box>

        <Box data-aos="fade-up">
          <Efficiency />
        </Box>

        <Box bgColor={COLOR.BLACK}>
          <MainContainer data-aos="fade-up" bg={COLOR.BLACK}>
            <Products />
          </MainContainer>
        </Box>

        <Box bg={`linear-gradient(to bottom, ${COLOR.NAVY}, ${COLOR.DARK})`}>
          <MainContainer data-aos="fade-up">
            <Result />
          </MainContainer>
        </Box>

        <Box bgColor={COLOR.DARK}>
          <MainContainer bg={COLOR.DARK} pl={0} ml={0} data-aos="fade-up">
            <Certification />
          </MainContainer>
        </Box>

        <Box bgColor={COLOR.LIGHT}>
          <MainContainer bg={COLOR.LIGHT} data-aos="fade-up">
            <ProductIntro />
          </MainContainer>
        </Box>

        <Box data-aos="fade-up">
          <ProductIntro2 />
        </Box>

        <Box bgColor={COLOR.GRAY}>
          <MainContainer data-aos="fade-up" bg={COLOR.GRAY}>
            <ProductIntro3 />
          </MainContainer>
        </Box>
        <Box bgColor={COLOR.NAVY}>
          <MainContainer data-aos="fade-up" bg={COLOR.NAVY}>
            <SocialMedia />
          </MainContainer>
        </Box>

        <Box data-aos="fade-up">
          <Testimony />
        </Box>
      </BrandLayout>
    </>
  )
}

export default Zero2One
